import { db, firestore } from '@/shared/services/firebase'

const getAreas = accountId => new Promise((resolve, reject) => {
  db.collection('areas')
    .where('accountId', '==', accountId)
    .get()
    .then(snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      resolve(data)
    })
    .catch(error => {
      reject(error)
    })
})

const getAreasByAccounts = accountIds => new Promise((resolve, reject) => {
  db.collection('areas')
    .where('accountId', 'in', accountIds)
    .get()
    .then(snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      resolve(data)
    })
    .catch(error => {
      reject(error)
    })
})

const addAreaToGroup = async (areaGroupId, accountId, areaId, groupName = '') => {
  // Create area group if it doesn't exist otherwise add area to area group, use await
    const areaGroupRef = await db.collection('areaGroups').doc(areaGroupId).get()
    if (!areaGroupRef.exists) {
      await db.collection('areaGroups').doc(areaGroupId).set({
        accounts: [accountId],
        areas: [areaId],
        groupName
      })
    } else {
      await db.collection('areaGroups').doc(areaGroupId).update({
        accounts: firestore.FieldValue.arrayUnion(accountId),
        areas: firestore.FieldValue.arrayUnion(areaId)
      })
    }
}

const removeAreaFromGroup = async (areaGroupId, areaId, accountId = null) => {
  // Remove area from area group, use await
  await db.collection('areaGroups').doc(areaGroupId).update({
    accounts: firestore.FieldValue.arrayRemove(accountId),
    areas: firestore.FieldValue.arrayRemove(areaId)
  })
}

const getAreaGroups = async () => {
  // Get all area groups, use await
  const areaGroupsRef = await db.collection('areaGroups').get()
  const areaGroups = areaGroupsRef.docs.map(doc => {
    const item = doc.data()
    item.id = doc.id
    return item
  })
  return areaGroups
}

const getAreaGroup = areaGroupId => new Promise((resolve, reject) => {
  db.collection('areaGroups')
    .doc(areaGroupId)
    .get()
    .then(doc => {
      if (doc.exists) {
        const item = doc.data()
        item.id = doc.id
        resolve(item)
      }
    })
    .catch(error => {
      reject(error)
    })
}
)

const getAreaById = areaId => new Promise((resolve, reject) => {
  db.collection('areas')
    .doc(areaId)
    .get()
    .then(doc => {
      if (doc.exists) {
        const item = doc.data()
        item.id = doc.id
        resolve(item)
      }
    })
    .catch(error => {
      reject(error)
    })
})

const userHasWorkedInArea = async shift => {
  try {
    const snapshot = await db.collection('shifts')
      .where('areaId', '==', shift.areaId)
      .where('assignedTo', '==', shift.assignedTo)
      .where('status', '==', 'confirmed')
      .limit(1)
      .get()
    if (snapshot.docs.length > 0) {
      return true
    }
    return false
  } catch (error) {
    return false
  }
}

export {
  getAreas,
  getAreaById,
  getAreasByAccounts,
  userHasWorkedInArea,
  getAreaGroups,
  getAreaGroup,
  addAreaToGroup,
  removeAreaFromGroup
}
